export default "__VITE_ASSET__BCwdl8Gt__"